import React from 'react';
import { Modal, Button, Typography } from 'antd';

const { Text } = Typography;

export interface ModalDinamicoProps {
    visible: boolean;
    onClose: () => void;
    title?: React.ReactNode;
    headerIcon?: React.ReactNode;
    headerBgColor?: string;
    headerTextColor?: string;
    children?: React.ReactNode;
    footer?: React.ReactNode;
    width?: number | string;
    confirmText?: string;
    cancelText?: string;
    onConfirm?: () => Promise<void> | void;
    confirmDisabled?: boolean;
    confirmLoading?: boolean;
    confirmButtonColor?: string;
    showFooter?: boolean;
}

export const ModalDinamico: React.FC<ModalDinamicoProps> = ({
    visible,
    onClose,
    title,
    headerIcon,
    headerBgColor = '#1890ff',
    headerTextColor = '#FFF',
    children,
    footer,
    width = 600,
    confirmText,
    cancelText = 'Cancelar',
    onConfirm,
    confirmDisabled = false,
    confirmLoading = false,
    confirmButtonColor,
    showFooter = true,
}) => {
    if (!visible) return null;

    const handleConfirm = async () => {
        if (onConfirm) {
            await onConfirm();
        }
    };

    const activeConfirmBgColor = confirmButtonColor || (confirmDisabled ? '#F68B9C' : headerBgColor);

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            closable={false}
            width={width}
            bodyStyle={{ padding: 0 }}
            style={{
                borderRadius: 8,
                overflow: 'hidden'
            }}
            centered
        >
            {title && (
                <div
                    style={{
                        backgroundColor: headerBgColor,
                        padding: '14px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        color: headerTextColor,
                    }}
                >
                    {headerIcon}
                    <Text style={{ color: headerTextColor, fontSize: 16, fontWeight: 600 }}>
                        {title}
                    </Text>
                </div>
            )}

            <div style={{ padding: '20px 24px 16px 24px' }}>
                {children}
            </div>

            {showFooter && (
                footer !== undefined ? (
                    footer
                ) : (
                    <div
                        style={{
                            padding: '12px 24px 16px 24px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 12,
                            borderTop: '1px solid #F0F0F0',
                        }}
                    >
                        <Button
                            onClick={onClose}
                            style={{
                                backgroundColor: '#6C757D',
                                color: '#FFF',
                                borderColor: '#6C757D',
                                borderRadius: 4,
                                height: 36,
                                padding: '0 20px',
                                fontWeight: 500,
                            }}
                        >
                            {cancelText}
                        </Button>
                        {confirmText && onConfirm && (
                            <Button
                                disabled={confirmDisabled}
                                loading={confirmLoading}
                                onClick={handleConfirm}
                                style={{
                                    backgroundColor: activeConfirmBgColor,
                                    color: '#FFF',
                                    borderColor: 'transparent',
                                    borderRadius: 4,
                                    height: 36,
                                    padding: '0 20px',
                                    fontWeight: 500,
                                    opacity: confirmDisabled ? 0.6 : 1,
                                    cursor: confirmDisabled ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {confirmText}
                            </Button>
                        )}
                    </div>
                )
            )}
        </Modal>
    );
};
